import { render } from "./MarketingDigitalView.vue?vue&type=template&id=3a981bb6&scoped=true"
import script from "./MarketingDigitalView.vue?vue&type=script&lang=js"
export * from "./MarketingDigitalView.vue?vue&type=script&lang=js"

import "./MarketingDigitalView.vue?vue&type=style&index=0&id=3a981bb6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a981bb6"]])

export default __exports__